import { TextField, withStyles } from "@material-ui/core";

export const StyledInput = withStyles({
  root: {
    color: "#ededed",
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiFilledInput-input": {
      padding: 0,
    },
    "& .MuiInputBase-root ": {
      borderRadius: "1rem",
      fontSize: ".8rem",
      padding: "1rem",
      color: "#acacac",
    },
    "& .MuiFilledInput-multiline": {
      borderRadius: "1rem",
      fontSize: ".8rem",
      padding: "1rem",
      color: "#acacac",
    },
  },
})(TextField);
